import classNames from 'classnames'
import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'
import React from 'react'

import { Grid, Item } from 'core-components/library/grid'

import { List } from './descriptionLists/List'
import { PaymentMethods } from './details/PaymentMethods'

import styles from './Details.module.scss'

interface IProps {
  className?: string
  paymentTypes: IFormCategories[]
  industriesCovered: { name: string }[]
  noData: any
  categories: any
}

export const Details = ({
  className,
  paymentTypes,
  industriesCovered,
  noData,
  categories,
}: IProps) => {
  const setSource = (groupName: string) => {
    if (noData) {
      return []
    }
    return (
      (categories &&
        categories
          .filter((item: any) => item.tag_group.toLowerCase().replace(/\s+/g, '') === groupName)
          .sort((a: any, b: any) => a.id - b.id)) ||
      []
    )
  }

  return (
    <div className={classNames(styles.root, className || '')}>
      <Grid gap={16} alignItems={'center'} justify={'space-between'} bottomMargin={'small'}>
        <Item xs={12} md={7}>
          <PaymentMethods className={styles.paymentMethods} paymentTypes={paymentTypes} />
        </Item>

        <Item xs={12} md={4}>
          <List
            title={'partnerpreview-industries-covered'}
            selectedValues={industriesCovered}
            dataSource={setSource('hppartnerfirstspecializations')}
          />
        </Item>
      </Grid>
    </div>
  )
}
